import SvgIcon from '@mui/material/SvgIcon';
import { BRIGHT_BLUE } from 'utils/theme';

const CheckboxFilledIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 17 17"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        fontSize: props.width ?? '16px',
      }}
    >
      <path
        fill={BRIGHT_BLUE}
        stroke={BRIGHT_BLUE}
        d="M2.58203 0.804688H14.582C15.4105 0.804688 16.082 1.47626 16.082 2.30469V14.3047C16.082 15.1331 15.4105 15.8047 14.582 15.8047H2.58203C1.7536 15.8047 1.08203 15.1331 1.08203 14.3047V2.30469C1.08203 1.47626 1.7536 0.804688 2.58203 0.804688Z"
      ></path>
      <path
        fill={BRIGHT_BLUE}
        stroke={BRIGHT_BLUE}
        d="M14.082 0.804688H3.08203C1.97746 0.804688 1.08203 1.70012 1.08203 2.80469V13.8047C1.08203 14.9093 1.97746 15.8047 3.08203 15.8047H14.082C15.1866 15.8047 16.082 14.9093 16.082 13.8047V2.80469C16.082 1.70012 15.1866 0.804688 14.082 0.804688Z"
      ></path>
      <path
        stroke="white"
        strokeWidth="#1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.2461 4.62419L6.88591 11.9844L4.08203 9.1805"
      ></path>
    </SvgIcon>
  );
};

export default CheckboxFilledIcon;
